// extracted by mini-css-extract-plugin
export default {"peopleList":"index_peopleList_Tx5mr"};